module.exports = __webpack_public_path__ + "img/close.c41d4125.svg";